import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "svg",
    style: _normalizeStyle(_ctx.style)
  }, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.svg)))
  ], 4))
}